import { Button } from "@material-ui/core";
import {Alert,Backdrop,Box,CircularProgress,CssBaseline,FormControl,FormHelperText,Grid,InputLabel,MenuItem,Paper,Select,Snackbar,Stack,TextField,Toolbar,styled,} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { API_URL } from "../../Constants";
import { axiosClient, axiosClientCloud } from "../AxiosClient";
import { Typography } from "@mui/material";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import Swal from "sweetalert2";
import Autocomplete from "@mui/material/Autocomplete";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import CommerceRelationsTabs from "./CommerceRelationsTabs";

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
}));

const ButtonImage = styled(Button)({
  flexGrow: 0,
  borderRadius: "20px",
  gap: "10px",
  backgroundColor: "#ffff",
  color: "#161e55",
  margin: "0px 1rem",
  border: "1px solid rgba(11, 10, 10, 0.17)",
  "&:hover": {
    backgroundColor: "#A8C8AF",
  },
});

const ButtonAdd = styled(Button)({
  flexGrow: 0,
  borderRadius: "20px",
  gap: "10px",
  backgroundColor: "#161e55",
  color: "#ffff",
  margin: "0px 1rem",
  "&:hover": {
    backgroundColor: "#A8C8AF",
  },
});

const ButtonCancel = styled(Button)({
  flexGrow: 0,
  borderRadius: "20px",
  gap: "10px",
  backgroundColor: "#ffff",
  color: "#161e55",
  margin: "0px 1rem",
  border: "1px solid #161e55",
  "&:hover": {
    backgroundColor: "#f5f5f5",
  },
});

const ButtonEdit = styled(Button)({
  color: "#161e55",
  "&:hover": {
    color: "#A8C8AF",
  },
});

const TextMessage = styled(FormHelperText)({
  color: "green",
});

const TextError = styled(TextMessage)({
  color: "red",
});

const urlApi = API_URL;

export default function EditCommerceForm() {
  const { commerceUuid } = useParams();
  const navigate = useNavigate();

  const periodicitiesDesembolso = [
    "Quincenal",
    "Mensual",
    "Bimestral",
    "Trimestral",
  ];
  const whatsappVersions = ["V1", "V2"];
  const tipoDocumento = ["NIT", "CC", "CE"];
  const taxPayerType = ["PERSONA JURIDICA", "PERSONA NATURAL"];
  const ivaResponsable = ["SI ES RESPONSABLE", "NO ES RESPONSABLE"];

  const [isLoading, setIsLoading] = useState(true);
  const [isIvaResponsable, setIvaResponsable] = useState("");
  const [razonSocial, setRazonSocial] = useState("");
  const [typeDocumento, setTypeDocumento] = useState("");
  const [numberDocument, setNumberDocument] = useState("");
  const [verificationDigit, setVerificationDigit] = useState("");
  const [celular, setCelular] = useState("");
  const [department, setDepartment] = useState("");
  const [departmentName, setDepartmentName] = useState(null);
  const [citysSiigoList, setCitysSiigoList] = useState([]);
  const [selectedCity, setSelectedCity] = useState("");
  const [periodicityDesembolso, setPeriodicityDesembolso] = useState("");
  const [whatsappVersion, setWhatsappVersion] = useState("");
  const [bank, setBank] = useState("");
  const [address, setAddress] = useState("");
  const [numeroSedes, setNumeroSedes] = useState("");
  const [email, setEmail] = useState("");
  const [city, setCity] = useState("");
  const [webSite, setWebSite] = useState("");
  const [sector, setSector] = useState("");
  const [errorRazonSocial, setErrorRazonSocial] = useState(false);
  const [message, setMessage] = useState("");
  const [severity, setSeverity] = useState("");
  const [CellphoneCommerce, setCellphoneCommerce] = useState("");
  const [nombreComercio, setNombreComercio] = useState("");
  const [percentageComision, setPercentageComission] = useState("");
  const [industryTypes, setIndustryTypes] = useState([]);
  const [departaments, setDepartaments] = useState([]);
  const [isBackdrop, setIsBackdrop] = useState(false);
  const [isSnackbar, setIsSnackbar] = useState(false);
  const [firstName, setFirstName] = useState("");
  const [secondName, setSecondName] = useState("");
  const [firstLastName, setFirstLastName] = useState("");
  const [secondLastName, setSecondLastName] = useState("");
  const [comercialName, setComercialName] = useState("");
  const [tipoContribuyente, setTipoContribuyente] = useState("");
  const [dense, setDense] = useState(false);
  const [secondary, setSecondary] = useState(false);
  const [third, setThird] = useState(false);
  const [fourth, setFourth] = useState(false);
  const [fifth, setFifth] = useState(false);
  const [contactNames, setContactNames] = useState("");
  const [contactPhoneNumber, setContactPhoneNumber] = useState("");
  const [contactLastNames, setContactLastNames] = useState("");
  const [inputValue, setInputValue] = useState("");

  const [commerceOldId, setCommerceOldId] = useState(null);

  const handleChangeRazonSocial = (event) => {
    setRazonSocial(event.target.value);
  };

  const handleChangeComercialName = (event) => {
    setComercialName(event.target.value);
  };

  const handleChangeNombreComercio = (event) => {
    setNombreComercio(event.target.value);
  };

  const handleClosedSnack = (event, reason) => {
    if (reason == "clickaway") {
      return;
    }
    setIsSnackbar(false);
  };

  const handleChangeTypeDocumento = (event) => {
    setTypeDocumento(event.target.value);
  };

  const handleChangeTipoContribuyente = (event) => {
    setTipoContribuyente(event.target.value);
  };

  const handleChangeNumberDocument = (event) => {
    setNumberDocument(event.target.value);
  };

  const handleChangeVerificationDigit = (event) => {
    setVerificationDigit(event.target.value);
  };

  const handleChangeAddress = (event) => {
    const inputValue = event.target.value;
    const normalizedValue = inputValue.replace(/[^a-zA-Z0-9áéíóúÁÉÍÓÚ\s]/g, "");
    setAddress(normalizedValue);
  };

  const handleChangeNumeroSedes = (event) => {
    setNumeroSedes(event.target.value);
  };

  const handleChangeEmail = (event) => {
    setEmail(event.target.value);
  };

  const handleChangeCity = (event) => {
    setCity(event.target.value);
  };

  const handleChangeWebSite = (event) => {
    setWebSite(event.target.value);
  };

  const handleChangeDepartment = (event) => {
    const selectedUuid = event.target.value;
    const selectedDept = departaments.find(
      (dept) => dept.uuid === selectedUuid
    );
    setDepartment(selectedUuid);
    setDepartmentName(selectedDept?.name || null);
  };

  const handleChangePeriodicityDesembolso = (event) => {
    setPeriodicityDesembolso(event.target.value);
  };

  const handleChangeWhatsappVersion = (event) => {
    setWhatsappVersion(event.target.value);
  };

  const handleChangeBank = (event) => {
    setBank(event.target.value);
  };

  const handleChangeSector = (event) => {
    setSector(event.target.value);
  };

  const handleChangeCellphoneCommerce = (event) => {
    const inputValue = event.target.value;
    if (/^\d{0,10}$/.test(inputValue)) {
      setCellphoneCommerce(inputValue);
    }
  };

  const handleChangePercentageComissionCommerce = (event) => {
    setPercentageComission(event.target.value);
  };

  const handleChangeFirstName = (event) => {
    setFirstName(event.target.value);
  };

  const handleChangeSecondName = (event) => {
    setSecondName(event.target.value);
  };

  const handleChangeFirstLastName = (event) => {
    setFirstLastName(event.target.value);
  };

  const handleChangeSecondLastName = (event) => {
    setSecondLastName(event.target.value);
  };

  const handleChangeIvaResponsable = (event) => {
    setIvaResponsable(event.target.value);
  };

  const handleChangeContactNames = (event) => {
    setContactNames(event.target.value);
  };

  const handleChangeContactLastNames = (event) => {
    setContactLastNames(event.target.value);
  };

  const handleChangeContactPhoneNumber = (event) => {
    setContactPhoneNumber(event.target.value);
  };

  const handleGoBack = () => {
    navigate("/homeAdmin/comercios");
  };

  const handleSubmitEditCommerce = (event) => {
    event.preventDefault();

    if (!nombreComercio) {
      setErrorRazonSocial(true);
      setMessage("El nombre de comercio es obligatorio");
      setSeverity("error");
      setIsSnackbar(true);
      return;
    }

    const regexValue = /^(100(\.0{1,2})?|(\d{1,2})(\.\d{1,2})?)$/;
    if (percentageComision && !regexValue.test(percentageComision)) {
      setMessage("El porcentaje debe ser entre 0 y 100 con máximo 2 decimales");
      setSeverity("error");
      setIsSnackbar(true);
      return;
    }

    const taxResponsibilities = [];
    if (dense) taxResponsibilities.push("NO_APLICA_OTROS");
    if (secondary) taxResponsibilities.push("GRAN_CONTRIBUYENTE");
    if (third) taxResponsibilities.push("AUTORRETENEDOR");
    if (fourth) taxResponsibilities.push("AGENTE_RETENCION_IVA");
    if (fifth) taxResponsibilities.push("REGIMEN_SIMPLE_TRIBUTACION");

    const body = {
      name: nombreComercio || "",
      legalName: razonSocial || "",
      documentType: typeDocumento || "CC",
      documentNumber: numberDocument?.replace(/\s+/g, "") || "",
      cellphone: CellphoneCommerce || "",
      address: address || "",
      companyName: razonSocial || nombreComercio,
      city: selectedCity || "",
      locationsNumber: numeroSedes ? parseInt(numeroSedes) : null,
      email: email || "",
      website: webSite || "",
      departaments: department || null,
      sectorCommerceUuid: sector || null,
      regionUuid: department || null,
      periodicityDesembolso: periodicityDesembolso || "Quincenal",
      bank: bank || "",
      department: departmentName || null,
      whatsappVersion: whatsappVersion || "V1",
      comissionPercentage: percentageComision
        ? parseFloat(percentageComision) / 100
        : null,
      verificationDigit: verificationDigit || "",
      name1: firstName || "",
      name2: secondName || "",
      comercialName: comercialName || "",
      lastName1: firstLastName || "",
      lastName2: secondLastName || "",
      taxPayerType: tipoContribuyente || "",
      contactsName: contactNames || "",
      contactsLastName: contactLastNames || "",
      contactNumber: contactPhoneNumber || "",
      ivaResponsable: isIvaResponsable === "SI ES RESPONSABLE",
      taxResponsibilities:
        taxResponsibilities.length > 0 ? taxResponsibilities : null,
    };

    if (!nombreComercio) {
      setErrorRazonSocial(true);
      return;
    }

    if (percentageComision && !regexValue.test(percentageComision)) {
      return;
    }

    setIsBackdrop(true);
    Swal.fire({
      title: "¿Estás seguro de editar este comercio?",
      text: "Revisa que los datos sean correctos antes de continuar.",
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#161e55",
      cancelButtonColor: "#d33",
      confirmButtonText: "Sí, editar",
      cancelButtonText: "Cancelar",
    }).then((result) => {
      if (result.isConfirmed) {
        setIsBackdrop(true);
        axiosClient
          .patch(`/v1/commerces/${commerceUuid}`, body)
          .then((response) => {
            setIsBackdrop(false);
            if (response.status === 200) {
              Swal.fire("Resultado", response.data.message || "Comercio editado exitosamente", "success").then(() => {
                navigate("/homeAdmin/comercios");
              });
            }
          })
          .catch((error) => {
            setIsBackdrop(false);
            Swal.fire(
              "Error",
              error.response?.data?.message || "No se pudo editar el comercio",
              "error"
            );
          });
      } else {
        setIsBackdrop(false);
      }
    });
  };

  useEffect(() => {
    if (localStorage.getItem("userUuid") == null) {
      window.location = "/admin";
    }

    const loadData = async () => {
      setIsLoading(true);
      try {
        const [regionsRes, citysSiigoRes, sectorsRes] = await Promise.all([
          axiosClientCloud.get(`/v1/regions`),
          axiosClient.get(`/v1/regions/regionSiigo`),
          axiosClientCloud.get(`/v1/sectors-commerce`),
        ]);

        if (regionsRes.status === 200) setDepartaments(regionsRes.data);
        if (citysSiigoRes.status === 200) setCitysSiigoList(citysSiigoRes.data);
        if (sectorsRes.status === 200) setIndustryTypes(sectorsRes.data);

        const commerceRes = await axiosClient.get(`/v1/commerces/${commerceUuid}`);
        if (commerceRes.status === 200) {
          const data = commerceRes.data;
          setCommerceOldId(data.oldId || data.id || null);
          setNombreComercio(data.name || "");
          setRazonSocial(data.legalName || data.companyName || "");
          setTypeDocumento(data.documentType || "");
          setNumberDocument(data.documentNumber || "");
          setVerificationDigit(data.verificationDigit || "");
          setCellphoneCommerce(data.cellphone || "");
          setAddress(data.address || "");
          setNumeroSedes(data.locationsNumber ? String(data.locationsNumber) : "");
          setEmail(data.email || "");
          setSelectedCity(data.city || "");
          setInputValue(data.city || "");
          setWebSite(data.website || "");
          setSector(data.sectorCommerceUuid || "");
          setDepartment(data.regionUuid || "");
          setPeriodicityDesembolso(data.periodicityDesembolso || "");
          setBank(data.bank || "");
          setWhatsappVersion(data.whatsappVersion || "");
          setPercentageComission(
            data.comissionPercentage != null
              ? String(parseFloat(data.comissionPercentage) * 100)
              : ""
          );
          setFirstName(data.name1 || "");
          setSecondName(data.name2 || "");
          setFirstLastName(data.lastName1 || "");
          setSecondLastName(data.lastName2 || "");
          setComercialName(data.comercialName || "");
          setTipoContribuyente(data.taxPayerType || "");
          setContactNames(data.contactsName || "");
          setContactLastNames(data.contactsLastName || "");
          setContactPhoneNumber(data.contactNumber || "");
          setIvaResponsable(
            data.ivaResponsable ? "SI ES RESPONSABLE" : data.ivaResponsable === false ? "NO ES RESPONSABLE" : ""
          );

          if (data.department) {
            setDepartmentName(data.department);
          } else if (data.regionUuid && regionsRes.data) {
            const dept = regionsRes.data.find((d) => d.uuid === data.regionUuid);
            setDepartmentName(dept?.name || null);
          }

          const responsibilities = data.taxResponsibilities || [];
          setDense(responsibilities.includes("NO_APLICA_OTROS"));
          setSecondary(responsibilities.includes("GRAN_CONTRIBUYENTE"));
          setThird(responsibilities.includes("AUTORRETENEDOR"));
          setFourth(responsibilities.includes("AGENTE_RETENCION_IVA"));
          setFifth(responsibilities.includes("REGIMEN_SIMPLE_TRIBUTACION"));
        }
      } catch (error) {
        console.log("Error loading commerce data: " + error.message);
        Swal.fire("Error", "No se pudo cargar la información del comercio", "error");
      } finally {
        setIsLoading(false);
      }
    };

    loadData();
  }, [commerceUuid]);

  const isNameFieldsEnabled = typeDocumento === "CC" || typeDocumento === "CE";

  if (isLoading) {
    return (
      <React.Fragment>
        <CssBaseline />
        <Toolbar />
        <Box sx={{ width: "100%", display: "flex", justifyContent: "center", alignItems: "center", minHeight: "50vh" }}>
          <CircularProgress color="success" />
        </Box>
      </React.Fragment>
    );
  }

  return (
    <React.Fragment>
      <CssBaseline></CssBaseline>
      <Toolbar></Toolbar>
      <Box sx={{ width: "100%" }}>
        <Stack spacing={2}>
          <Item>.</Item>
          <Item></Item>
          <Grid container>
            <Grid item>
              <Box display={"flex"}>
                <h1>Edición de comercio</h1>
              </Box>
            </Grid>
          </Grid>
          <Box container sx={{ width: "75vw" }}>
            <form onSubmit={handleSubmitEditCommerce}>
              <Grid container spacing={1} mt={0} mb={1}>
                <Grid item xs={5}>
                  <FormControl fullWidth>
                    <InputLabel id="tipo-documento">
                      Tipo de documento
                    </InputLabel>
                    <Select
                      labelId="tipo-documento"
                      id="tipoDocumento"
                      label="Tipo de documento"
                      value={typeDocumento}
                      onChange={handleChangeTypeDocumento}
                    >
                      {tipoDocumento.map((tipoDocument) => (
                        <MenuItem key={tipoDocument} value={tipoDocument}>
                          {tipoDocument}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>

                <Grid item xs={5}>
                  <FormControl fullWidth>
                    <TextField
                      id="numero-documento"
                      label="Número de Documento"
                      variant="outlined"
                      value={numberDocument}
                      onChange={handleChangeNumberDocument}
                    ></TextField>
                  </FormControl>
                </Grid>

                <Grid item xs={2}>
                  <FormControl fullWidth>
                    <TextField
                      id="digito-verificacion"
                      label="Digíto de verificación"
                      variant="outlined"
                      value={verificationDigit}
                      onChange={handleChangeVerificationDigit}
                    ></TextField>
                  </FormControl>
                </Grid>
              </Grid>

              <Grid container spacing={1} mt={0} mb={1}>
                <Grid item xs={12}>
                  <FormControl fullWidth>
                    <TextField
                      id="nombre-comercio"
                      label="Nombre de comercio"
                      variant="outlined"
                      value={nombreComercio}
                      onChange={handleChangeNombreComercio}
                    ></TextField>
                  </FormControl>
                  {errorRazonSocial && <TextMessage></TextMessage>}
                </Grid>
              </Grid>

              <Grid container spacing={1} mt={0} mb={1}>
                <Grid item xs={4}>
                  <FormControl fullWidth>
                    <TextField
                      id="celular"
                      label="Celular"
                      variant="outlined"
                      value={CellphoneCommerce}
                      onChange={handleChangeCellphoneCommerce}
                      inputProps={{
                        maxLength: 10,
                        inputMode: "numeric",
                      }}
                    ></TextField>
                  </FormControl>
                </Grid>

                <Grid item xs={8}>
                  <FormControl fullWidth>
                    <InputLabel id="department">Departamento</InputLabel>
                    <Select
                      labelId="department"
                      id="departamento"
                      label="Departamento"
                      value={department}
                      onChange={handleChangeDepartment}
                      MenuProps={{
                        PaperProps: {
                          style: {
                            width: "calc(50% - 32px)",
                            maxHeight: 300,
                          },
                        },
                      }}
                    >
                      {departaments?.map((items) => (
                        <MenuItem key={items.uuid} value={items.uuid}>
                          {items.name}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>

              <Grid container spacing={1} mt={0} mb={1}>
                <Grid item xs={5}>
                  <Autocomplete
                    id="ciudad-search"
                    options={citysSiigoList}
                    value={selectedCity}
                    onChange={(event, newValue) => {
                      setSelectedCity(newValue);
                    }}
                    inputValue={inputValue}
                    onInputChange={(event, newInputValue) => {
                      setInputValue(newInputValue);
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Buscar ciudad"
                        variant="outlined"
                      />
                    )}
                    filterOptions={(options, state) => {
                      return options.filter((option) =>
                        option
                          .toLowerCase()
                          .includes(state.inputValue.toLowerCase())
                      );
                    }}
                    sx={{
                      "& .MuiAutocomplete-popupIndicator": {
                        transform: "none",
                      },
                    }}
                  />
                </Grid>

                <Grid item xs={5}>
                  <FormControl fullWidth>
                    <TextField
                      id="address"
                      label="Dirección"
                      variant="outlined"
                      value={address}
                      onChange={handleChangeAddress}
                    ></TextField>
                  </FormControl>
                </Grid>
                <Grid item xs={2}>
                  <FormControl fullWidth>
                    <TextField
                      id="numeroSedes"
                      label="Número de sedes"
                      variant="outlined"
                      value={numeroSedes}
                      onChange={handleChangeNumeroSedes}
                    ></TextField>
                  </FormControl>
                </Grid>
              </Grid>

              <Grid container spacing={1} mt={0} mb={1}>
                <Grid item xs={4}>
                  <FormControl fullWidth>
                    <InputLabel id="periodicity-desembolso">
                      Periodicidad de Desembolso
                    </InputLabel>
                    <Select
                      labelId="periodicity-desembolso"
                      id="periodicidadDesembolso"
                      label="Periodicidad de Desembolso"
                      value={periodicityDesembolso}
                      onChange={handleChangePeriodicityDesembolso}
                    >
                      {periodicitiesDesembolso.map((items) => (
                        <MenuItem key={items} value={items}>
                          {items}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>

                <Grid item xs={4}>
                  <FormControl fullWidth>
                    <TextField
                      id="banco"
                      label="Banco"
                      variant="outlined"
                      value={bank}
                      onChange={handleChangeBank}
                    ></TextField>
                  </FormControl>
                </Grid>

                <Grid item xs={4}>
                  <FormControl fullWidth>
                    <InputLabel id="sectors">Sector</InputLabel>
                    <Select
                      labelId="sectors"
                      id="sector"
                      label="Sector"
                      value={sector}
                      onChange={handleChangeSector}
                    >
                      {industryTypes?.map((items) => (
                        <MenuItem key={items.uuid} value={items.uuid}>
                          {items.name}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>

              <Grid container spacing={1} mt={0} mb={1}>
                <Grid item xs={6}>
                  <FormControl fullWidth>
                    <TextField
                      id="website"
                      label="Website"
                      variant="outlined"
                      type="text"
                      value={webSite}
                      onChange={handleChangeWebSite}
                    ></TextField>
                  </FormControl>
                </Grid>

                <Grid item xs={6}>
                  <FormControl fullWidth>
                    <TextField
                      id="email"
                      label="Email"
                      variant="outlined"
                      type="email"
                      value={email}
                      onChange={handleChangeEmail}
                    ></TextField>
                  </FormControl>
                </Grid>
              </Grid>

              <Grid container spacing={1} mt={0} mb={1}>
                <Grid item xs={6}>
                  <FormControl fullWidth>
                    <InputLabel id="whatsapp-version">
                      Versión de Whatsapp
                    </InputLabel>
                    <Select
                      labelId="whatsapp-version"
                      id="whatsappVersion"
                      label="Versión de Whatsapp"
                      value={whatsappVersion}
                      onChange={handleChangeWhatsappVersion}
                    >
                      {whatsappVersions.map((items) => (
                        <MenuItem key={items} value={items}>
                          {items}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>

                <Grid item xs={6}>
                  <FormControl fullWidth>
                    <TextField
                      id="comission-percentage"
                      label="Porcentaje de comisión"
                      placeholder="1.3%"
                      variant="outlined"
                      value={percentageComision}
                      onChange={handleChangePercentageComissionCommerce}
                    ></TextField>
                  </FormControl>
                  {percentageComision != "" &&
                  !/^(100(\.0{1,2})?|(\d{1,2})(\.\d{1,2})?)$/.test(
                    percentageComision
                  ) ? (
                    <TextMessage>
                      Debe ser numerico y estar entre 0 y 100
                    </TextMessage>
                  ) : (
                    ""
                  )}
                </Grid>
              </Grid>

              <Grid item>
                <Box display={"flex"}>
                  <h1>
                    Datos para efectos de creación en Siigo y facturación{" "}
                  </h1>
                </Box>
              </Grid>

              <Grid container spacing={1} mt={0} mb={1}>
                <Grid item xs={6}>
                  <FormControl fullWidth>
                    <TextField
                      id="razon-social"
                      label="Razón social"
                      variant="outlined"
                      value={razonSocial}
                      onChange={handleChangeRazonSocial}
                    ></TextField>
                  </FormControl>
                  {errorRazonSocial && <TextMessage></TextMessage>}
                </Grid>
                <Grid item xs={6}>
                  <FormControl fullWidth>
                    <TextField
                      id="comercial-name"
                      label="Nombre comercial"
                      variant="outlined"
                      value={comercialName}
                      onChange={handleChangeComercialName}
                    ></TextField>
                  </FormControl>
                  {errorRazonSocial && <TextMessage></TextMessage>}
                </Grid>
              </Grid>

              {isNameFieldsEnabled && (
                <Grid container spacing={1} mt={0} mb={1}>
                  <Grid item xs={3}>
                    <FormControl fullWidth>
                      <TextField
                        id="firstName"
                        label="Primer nombre"
                        variant="outlined"
                        value={firstName}
                        onChange={handleChangeFirstName}
                      ></TextField>
                    </FormControl>
                  </Grid>
                  <Grid item xs={3}>
                    <FormControl fullWidth>
                      <TextField
                        id="secondName"
                        label="Segundo Nombre (Opcional)"
                        variant="outlined"
                        value={secondName}
                        onChange={handleChangeSecondName}
                      ></TextField>
                    </FormControl>
                  </Grid>
                  <Grid item xs={3}>
                    <FormControl fullWidth>
                      <TextField
                        id="last-name-one"
                        label="Primer apellido"
                        variant="outlined"
                        value={firstLastName}
                        onChange={handleChangeFirstLastName}
                      ></TextField>
                    </FormControl>
                  </Grid>
                  <Grid item xs={3}>
                    <FormControl fullWidth>
                      <TextField
                        id="last-name-two"
                        label="Segundo Apellido"
                        variant="outlined"
                        value={secondLastName}
                        onChange={handleChangeSecondLastName}
                      ></TextField>
                    </FormControl>
                  </Grid>
                </Grid>
              )}

              <Grid container spacing={1} mt={0} mb={1}>
                <Grid item xs={6}>
                  <FormControl fullWidth>
                    <InputLabel id="tipo-contribuyente">
                      Tipo de contribuyente
                    </InputLabel>
                    <Select
                      labelId="tipo-contribuyente"
                      id="tipoContribuyente"
                      label="Tipo de Contribuyente"
                      value={tipoContribuyente}
                      onChange={handleChangeTipoContribuyente}
                    >
                      {taxPayerType.map((tipoContribuyente) => (
                        <MenuItem
                          key={tipoContribuyente}
                          value={tipoContribuyente}
                        >
                          {tipoContribuyente}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={6}>
                  <FormControl fullWidth>
                    <InputLabel id="is-iva-reponsable">
                      Responsable iva
                    </InputLabel>
                    <Select
                      labelId="is-iva-reponsable"
                      id="ivaResponsable"
                      label="Responsable de iva"
                      value={isIvaResponsable}
                      onChange={handleChangeIvaResponsable}
                    >
                      {ivaResponsable.map((ivaResponsable) => (
                        <MenuItem key={ivaResponsable} value={ivaResponsable}>
                          {ivaResponsable}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>

              <Grid item>
                <Box display="flex">
                  <Typography variant="h6">
                    Datos de persona de contacto
                  </Typography>
                </Box>
              </Grid>

              <Grid container spacing={1} mt={0} mb={1}>
                <Grid item xs={4}>
                  <FormControl fullWidth>
                    <TextField
                      id="ContactsName"
                      label="Nombres de contacto "
                      variant="outlined"
                      value={contactNames}
                      onChange={handleChangeContactNames}
                    ></TextField>
                  </FormControl>
                </Grid>

                <Grid item xs={4}>
                  <FormControl fullWidth>
                    <TextField
                      id="last-name-one"
                      label="Apellidos de contacto"
                      variant="outlined"
                      value={contactLastNames}
                      onChange={handleChangeContactLastNames}
                    ></TextField>
                  </FormControl>
                </Grid>

                <Grid item xs={4}>
                  <FormControl fullWidth>
                    <TextField
                      id="contact-number-phone"
                      label="Célular de persona de contacto"
                      variant="outlined"
                      value={contactPhoneNumber}
                      onChange={handleChangeContactPhoneNumber}
                      inputProps={{
                        maxLength: 10,
                        inputMode: "numeric",
                      }}
                    ></TextField>
                  </FormControl>
                </Grid>
              </Grid>

              <Grid item>
                <Box display="flex">
                  <Typography variant="h6">
                    Responsabilidades fiscales (Casilla N° 53 del RUT)
                  </Typography>
                </Box>
              </Grid>

              <FormGroup row>
                <Grid container spacing={1} mt={0} mb={1}>
                  <Grid item xs={2.4}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={dense}
                          onChange={(event) => setDense(event.target.checked)}
                        />
                      }
                      label="R-99-PN No Aplica - Otros"
                    />
                  </Grid>

                  <Grid item xs={2.2}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={secondary}
                          onChange={(event) =>
                            setSecondary(event.target.checked)
                          }
                        />
                      }
                      label="O-13 Gran contribuyente"
                    />
                  </Grid>
                  <Grid item xs={2}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={third}
                          onChange={(event) => setThird(event.target.checked)}
                        />
                      }
                      label="O-15 Autorretenedor"
                    />
                  </Grid>
                  <Grid item xs={2.3}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={fourth}
                          onChange={(event) => setFourth(event.target.checked)}
                        />
                      }
                      label="O-23 Agente de retención IVA"
                    />
                  </Grid>
                  <Grid item xs={2.8}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={fifth}
                          onChange={(event) => setFifth(event.target.checked)}
                        />
                      }
                      label="O-47 Régimen simple de tributación"
                    />
                  </Grid>
                </Grid>
              </FormGroup>

              <CommerceRelationsTabs
                commerceUuid={commerceUuid}
                commerceOldId={commerceOldId}
                cities={citysSiigoList}
                departaments={departaments}
              />

              <Box textAlign={"center"} mb={8} mt={5.7} display="flex" justifyContent="center" gap={2}>
                <ButtonCancel onClick={handleGoBack}>Cancelar</ButtonCancel>
                <ButtonAdd type="submit">Guardar cambios</ButtonAdd>
              </Box>
            </form>
          </Box>
        </Stack>
      </Box>
      <Backdrop
        sx={{
          background: "rgba(255,255,255,0.1)",
          zIndex: "5",
          width: "50%",
          margin: "auto auto auto 30vw",
        }}
        open={isBackdrop}
      >
        <CircularProgress color="success" />
      </Backdrop>
      <Snackbar
        open={isSnackbar}
        autoHideDuration={5000}
        onClose={handleClosedSnack}
      >
        <Alert
          onClose={handleClosedSnack}
          severity={severity}
          sx={{ width: "100%" }}
        >
          {message}
        </Alert>
      </Snackbar>
    </React.Fragment>
  );
}
